/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-console */
export const loadApp = async () => {
  try {
    const { initBrowserContext } = await import(
      './setup-browser-context'
    );
    await initBrowserContext();

    if (!import.meta.env.DEV) {
      const { initLogging } = await import('./setup-logging');
      await initLogging();

      const { initFaro, setFaroUser } = await import(
        './setup-faro'
      );
      await initFaro();
      setFaroUser(window.browserContext?.getUsername?.());
    }

    const { initMocks } = await import('./setup-mocks');
    await initMocks();

    const { default: AppComponent } = await import(
      '../App.svelte'
    );

    console.time('Time');
    console.info('🏃 Initializing App');
    const app = new AppComponent({
      target: document.body
    });

    const { initHmr } = await import('./setup-hmr');

    initHmr(app);
    console.timeEnd('Time');
  } catch (err) {
    console.error(err);
    alert(err);
  }
};
